import { useTranslation } from "react-i18next";

import { cn } from "@/lib/cn";

type BrandMarkSize = "sm" | "md" | "lg";

const SIZE: Record<BrandMarkSize, string> = {
  sm: "text-lg",
  md: "text-xl",
  lg: "text-3xl sm:text-4xl",
};

/**
 * Product wordmark for chrome and auth. Source Serif matches the marketing
 * brand; body copy elsewhere stays IBM Plex Sans.
 */
export function BrandMark({
  size = "md",
  withKicker = false,
  tone = "default",
  className,
}: {
  size?: BrandMarkSize;
  /** Short line under the name (login panel). */
  withKicker?: boolean;
  /** `onDark` for photo / navy panels (login brand side). */
  tone?: "default" | "onDark";
  className?: string;
}) {
  const { t } = useTranslation("common");
  const onDark = tone === "onDark";

  return (
    <div className={cn("leading-tight", className)}>
      <p
        className={cn(
          "font-semibold tracking-tight",
          onDark ? "text-white" : "text-ink",
          SIZE[size],
        )}
        style={{ fontFamily: "var(--font-brand)" }}
      >
        {t("appName")}
      </p>
      {withKicker ? (
        <p className={cn("mt-1 text-sm", onDark ? "text-white/75" : "text-ink-muted")}>
          {t("brandKicker")}
        </p>
      ) : null}
    </div>
  );
}
